import { 
  ChartDataShape,
  LinearXAxis,
  LinearXAxisTickSeries,
  LinearYAxis,
  LinearYAxisTickSeries,
  LineChart,
  LineSeries,
} from 'reaviz';
import { atoms, themeColors } from 'misc'
import { useDataQuery } from 'generated';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { interpolateMagma as color } from 'd3-scale-chromatic'
type Data = {
  key: number|string,
  data: number|Data
}[]|undefined

export default function BarChart ({noText=false, label=false}) {
  const sic = useRecoilValue(atoms.sic)
  const year = useRecoilValue(atoms.year)
  const chartParam = useRecoilValue(atoms.chartParam)

  const [ data, setData ] = useState<ChartDataShape[]>()
  const { data:source, refetch:getData } = useDataQuery()

  useEffect(()=>{
    if(source?.counts){
      const groups = source.counts.reduce((agg:any,v)=>{
        if(v?.skill&&v.year){
          if(agg[v.skill]){
            agg[v.skill]?.push({key:v.year, data: Number(
              chartParam==='proportion'?
              v.counts?.[chartParam]:
              chartParam==='count'?
              v.counts?.[chartParam]:
              v[chartParam])  })
            return agg
          }else{
            return {...agg, [v.skill]: [{key:v.year, data: Number(
              chartParam==='proportion'?
              v.counts?.[chartParam]:
              chartParam==='count'?
              v.counts?.[chartParam]:
              v[chartParam])  }]}
          }
        }
      },{} as {[key:string]: Data })

      setData(
        // @ts-ignore
        Object.entries(groups).map(v=>({
          key: v[0],
          data: (v[1] as any).sort((a:any,b:any)=>a.key-b.key)
        }))
      )
    }
  },[source, setData, chartParam])

  useEffect(()=>{
    if(getData){
      getData({sic: String(sic)})
    }
  },[sic, getData])

  return <div style={{minWidth:345}}>
    <LineChart
      width={345}
      height={150}
      gridlines={null}
      xAxis={
        <LinearXAxis
          type="value"
          domain={[2014,2021]}
          axisLine={null}
          tickSeries={
            <LinearXAxisTickSeries 
              line={null} 
              label={null}
            />
          }
        />
      }
      yAxis={
        <LinearYAxis
          type='value'
          axisLine={null}
          domain={(!source)? 
            undefined:
            (chartParam==='proportion'||chartParam==='count')?
            [
              Number(source.counts__.agg?.min?.[chartParam]),
              Number(source.counts__.agg?.max?.[chartParam])
            ]:
            [
              Number(source.counts_.agg?.min?.[chartParam]),
              Number(source.counts_.agg?.max?.[chartParam])
            ]
          }
          tickSeries={
            <LinearYAxisTickSeries 
              line={null}
              label={null}
            />
          }
        />
      }
      data={ data }
      series={
        <LineSeries
          type='grouped'
      colorScheme={(_data, _index, active) => color(0.8-(_index/10)) /*(active ? themeColors[6] : themeColors[4])*/ }
        />
      }
    />
  </div>
}